import { install } from '@qcolor/utils/compoent';
import ColorPicker from './color-picker.vue';
ColorPicker.install = install;
export default ColorPicker;